module.exports = __webpack_public_path__ + "static/img/17.d417773d.png";